// Reusable styled confirm dialog (matches the cook-mode / scaling modals).
export function ConfirmDialog({
  title,
  message,
  confirmLabel,
  cancelLabel = "Cancel",
  confirmClass = "bg-terracotta hover:bg-terracotta-dark",
  reverseButtons = false,
  onConfirm,
  onCancel,
}: {
  title: string;
  message: string;
  confirmLabel: string;
  cancelLabel?: string;
  confirmClass?: string;
  // Swap the button positions (confirm on the left) — e.g. a second "are you
  // sure?" so the destructive button isn't where "Cancel" just was.
  reverseButtons?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
      onClick={onCancel}
    >
      <div
        className="w-full max-w-sm rounded-2xl bg-surface p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-xl font-bold text-ink mb-1">{title}</h2>
        <p className="text-sm text-ink-soft mb-6">{message}</p>
        <div className={`flex gap-2 ${reverseButtons ? "flex-row-reverse" : ""}`}>
          <button
            onClick={onCancel}
            className="flex-1 rounded-xl border border-line py-3 font-semibold text-ink-soft hover:bg-surface-2 cursor-pointer"
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            className={`flex-1 rounded-xl py-3 font-semibold text-white transition-colors cursor-pointer ${confirmClass}`}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
